import type { ConversationStatus } from '@/schemas/commons';

type StatusLabelKey = 'STATUS_ACTIVE' | 'STATUS_HANDOFF' | 'STATUS_CLOSED' | 'STATUS_TOOL_ERROR';

export const STATUS_STYLE: Record<ConversationStatus, { labelKey: StatusLabelKey; className: string }> = {
	active: { labelKey: 'STATUS_ACTIVE', className: 'border-green-200 bg-green-50 text-success' },
	handoff: { labelKey: 'STATUS_HANDOFF', className: 'border-yellow-200 bg-yellow-50 text-warning' },
	closed: { labelKey: 'STATUS_CLOSED', className: 'border-subtle bg-grey-25 text-subtle' },
	tool_error: { labelKey: 'STATUS_TOOL_ERROR', className: 'border-red-200 bg-red-50 text-error' },
};
